let num = 0

const counter = {
  get: () => num,
  addOne(){ num += 1 },
}

export default counter
